import removeSpecialChars from '@equifax-ui/utils/formatters/removeSpecialChars'

import { useStepHandler } from '@/hooks/useStepHandler'

import { API_FLOW_LABEL } from '@/constants'
import { SELF_CONSULT_FLOW_DATA } from '@/constants/steps'

export const useConsultation = () => {
  const { createSoftlead } = useStepHandler()

  const onSubmit = async ({ cnpj }) => {
    sessionStorage.setItem(
      API_FLOW_LABEL,
      JSON.stringify(SELF_CONSULT_FLOW_DATA)
    )

    const payload = { cnpj: removeSpecialChars(cnpj) }

    await createSoftlead({ payload, flowData: SELF_CONSULT_FLOW_DATA })
  }

  return {
    onSubmit
  }
}
